import React, { useEffect, useState, useRef } from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import { ColumnFilter } from '../components/ui/ColumnFilter';
// Hierarchical stato structure for optgroup rendering
const statoGroups = [{
  group: 'Processo',
  options: [{
    id: 'verifica-ammissibilita',
    label: 'In verifica di ammissibilità'
  }, {
    id: 'in-valutazione',
    label: 'In valutazione'
  }, {
    id: 'valutate',
    label: 'Valutate'
  }, {
    id: 'in-rendicontazione',
    label: 'In Rendicontazione'
  }, {
    id: 'rendicontate',
    label: 'Rendicontate'
  }]
}, {
  group: 'Esiti ammissibilità',
  options: [{
    id: 'non-ammesse',
    label: 'Non ammesse'
  }]
}, {
  group: 'Esiti valutazione',
  options: [{
    id: 'vincitori',
    label: 'Vincitori'
  }, {
    id: 'revoche',
    label: 'Revoche'
  }]
}];
// Flat list for label lookup
const allStatoOptions = statoGroups.flatMap(g => g.options);
const adminOptions = [{
  id: 'tutti',
  label: 'Tutti'
}, {
  id: 'da-assegnare',
  label: 'Da assegnare'
}, {
  id: 'assegnate-a-me',
  label: 'Assegnate a me'
}];
const valutatoreOptions = [{
  id: 'tutti',
  label: 'Tutti'
}, {
  id: 'da-assegnare',
  label: 'Da assegnare'
}, {
  id: 'assegnati-a-me',
  label: 'Assegnati a me'
}];
const azioniOptions = [{
  id: 'doc-da-controllare',
  label: 'Doc. da controllare'
}, {
  id: 'variazioni',
  label: 'Variazioni'
}];
const candidatureData = [{
  id: 1,
  bando: 'Bando 1 - Nuove Opere',
  settore: 'Musica',
  codice: '2025010402...',
  titolo: 'Progetto Test Nuove Opere Musicali',
  denominazione: 'Associazione Culturale Test ...',
  email: 'bando3.mario.v...'
}, {
  id: 2,
  bando: 'Bando 1 - Nuove Opere',
  settore: 'Teatro',
  codice: '2025010653...',
  titolo: 'Recusandae enim perspiciatis deserunt r...',
  denominazione: 'Longo, Milani e Battaglia e fi...',
  email: 'sp.bando3.genz...'
}, {
  id: 3,
  bando: 'Bando 1 - Nuove Opere',
  settore: 'Musica',
  codice: '2025010553...',
  titolo: 'Autem excepturi laborum maxime.',
  denominazione: 'Monti-Giuliani e figli',
  email: 'sp.bando3.eust...'
}, {
  id: 4,
  bando: 'Bando 1 - Nuove Opere',
  settore: 'Musica',
  codice: '2025010553...',
  titolo: 'Itaque sit nobis.',
  denominazione: 'Moretti-Romano Group',
  email: 'sp.bando3.vald...'
}, {
  id: 5,
  bando: 'Bando 1 - Nuove Opere',
  settore: 'Libro e lettura',
  codice: '2025010453...',
  titolo: 'Maxime quo eos incidunt.',
  denominazione: 'Moretti-Sartori SPA',
  email: 'sp.bando3.cleo...'
}, {
  id: 6,
  bando: 'Bando 1 - Nuove Opere',
  settore: 'Libro e lettura',
  codice: '2025010453...',
  titolo: 'Nihil accusamus minus.',
  denominazione: 'Bellini, Montanari e Ricci Gro...',
  email: 'sp.bando3.dona...'
}, {
  id: 7,
  bando: 'Bando 1 - Nuove Opere',
  settore: 'Danza',
  codice: '2025010353...',
  titolo: 'Tenetur modi doloremque.',
  denominazione: 'Ricci, Sartori e Palumbo SPA',
  email: 'sp.bando3.ivan...'
}, {
  id: 8,
  bando: 'Bando 1 - Nuove Opere',
  settore: 'Cinema',
  codice: '2025010253...',
  titolo: 'Consectetur quia doloribus sunt.',
  denominazione: 'Amato, Leone e Sorrentino e ...',
  email: 'sp.bando3.arcib...'
}, {
  id: 9,
  bando: 'Bando 1 - Nuove Opere',
  settore: 'Arti Visive, performati...',
  codice: '2025010153...',
  titolo: 'Nostrum sunt qui non.',
  denominazione: 'Gatti-Gentile SPA',
  email: 'sp.bando3.dami...'
}, {
  id: 10,
  bando: 'Bando 3 - Professionalizzazion...',
  settore: 'Danza',
  codice: '2025030353...',
  titolo: 'Occaecati soluta qui qui.',
  denominazione: 'Riva-Amato SPA',
  email: 'sp.bando6.giuli...'
}];
const columns = [{
  key: 'bando',
  label: 'BANDO',
  width: '18%'
}, {
  key: 'settore',
  label: 'SETTORE',
  width: '12%'
}, {
  key: 'codice',
  label: 'CODICE',
  width: '10%'
}, {
  key: 'titolo',
  label: 'TITOLO',
  width: '20%'
}, {
  key: 'denominazione',
  label: 'DENOMINAZIONE',
  width: '18%'
}, {
  key: 'email',
  label: 'EMAIL SOGG. PR...',
  width: '12%'
}, {
  key: 'azioni',
  label: 'AZIONI',
  width: '10%'
}];
interface TabView {
  id: string;
  name: string;
  statoFilter: string;
  adminFilter: string;
  valutatoreFilter: string;
  azioniFilters: string[];
  filters: {
    bando: string;
    settore: string;
    codice: string;
    titolo: string;
    denominazione: string;
    email: string;
  };
  searchQuery: string;
  rowsPerPage: number;
  currentPage: number;
}
const createDefaultTab = (id: string, name: string): TabView => ({
  id,
  name,
  statoFilter: 'tutti',
  adminFilter: 'tutti',
  valutatoreFilter: 'tutti',
  azioniFilters: [],
  filters: {
    bando: '',
    settore: '',
    codice: '',
    titolo: '',
    denominazione: '',
    email: ''
  },
  searchQuery: '',
  rowsPerPage: 10,
  currentPage: 1
});
export function Candidature() {
  const [tabs, setTabs] = useState<TabView[]>([createDefaultTab('tab-1', 'Tutte')]);
  const [activeTabId, setActiveTabId] = useState<string>('tab-1');
  const [editingTabId, setEditingTabId] = useState<string | null>(null);
  const [editTabName, setEditTabName] = useState('');
  const editInputRef = useRef<HTMLInputElement>(null);
  const activeTab = tabs.find(t => t.id === activeTabId) || tabs[0];
  const updateActiveTab = (updates: Partial<TabView>) => {
    setTabs(prev => prev.map(tab => tab.id === activeTabId ? {
      ...tab,
      ...updates
    } : tab));
  };
  const handleAddTab = () => {
    const newId = `tab-${Date.now()}`;
    const newName = `Vista ${tabs.length + 1}`;
    const newTab = createDefaultTab(newId, newName);
    setTabs([...tabs, newTab]);
    setActiveTabId(newId);
  };
  const handleRemoveTab = (e: React.MouseEvent, idToRemove: string) => {
    e.stopPropagation();
    if (tabs.length <= 1) return; // Keep at least one tab
    const newTabs = tabs.filter(t => t.id !== idToRemove);
    setTabs(newTabs);
    if (activeTabId === idToRemove) {
      // If closing active tab, switch to the last available tab
      setActiveTabId(newTabs[newTabs.length - 1].id);
    }
  };
  const handleDoubleClickTab = (tab: TabView) => {
    setEditingTabId(tab.id);
    setEditTabName(tab.name);
  };
  const handleSaveTabName = () => {
    if (editingTabId && editTabName.trim()) {
      setTabs(prev => prev.map(tab => tab.id === editingTabId ? {
        ...tab,
        name: editTabName.trim()
      } : tab));
    }
    setEditingTabId(null);
  };
  const handleKeyDownTabName = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSaveTabName();
    } else if (e.key === 'Escape') {
      setEditingTabId(null);
    }
  };
  useEffect(() => {
    if (editingTabId && editInputRef.current) {
      editInputRef.current.focus();
      editInputRef.current.select();
    }
  }, [editingTabId]);
  // Destructure active tab state for easier usage
  const {
    statoFilter,
    adminFilter,
    valutatoreFilter,
    azioniFilters,
    filters,
    searchQuery,
    rowsPerPage,
    currentPage
  } = activeTab;
  const totalItems = 127;
  const startItem = (currentPage - 1) * rowsPerPage + 1;
  const endItem = Math.min(currentPage * rowsPerPage, totalItems);
  const handleFilterChange = (key: keyof typeof filters, value: string) => {
    updateActiveTab({
      filters: {
        ...filters,
        [key]: value
      }
    });
  };
  const toggleAzione = (id: string) => {
    const newAzioni = azioniFilters.includes(id) ? azioniFilters.filter(a => a !== id) : [...azioniFilters, id];
    updateActiveTab({
      azioniFilters: newAzioni,
      currentPage: 1
    });
  };
  // Filter interdependency rules
  const statiWithValutatore = ['in-valutazione', 'valutate', 'vincitori', 'revoche'];
  const statiWithAzioni = ['verifica-ammissibilita', 'in-valutazione', 'valutate', 'vincitori', 'in-rendicontazione'];
  const isValutatoreRelevant = statoFilter === 'tutti' || statiWithValutatore.includes(statoFilter);
  const isAzioniRelevant = statoFilter === 'tutti' || statiWithAzioni.includes(statoFilter);
  // Cascade handler: when stato changes, reset incompatible filters
  const handleStatoChange = (newStato: string) => {
    const valRelevant = newStato === 'tutti' || statiWithValutatore.includes(newStato);
    const azRelevant = newStato === 'tutti' || statiWithAzioni.includes(newStato);
    updateActiveTab({
      statoFilter: newStato,
      currentPage: 1,
      valutatoreFilter: !valRelevant ? 'tutti' : valutatoreFilter,
      azioniFilters: !azRelevant ? [] : azioniFilters
    });
  };
  // Build composite title
  const buildFilterLabel = () => {
    const parts: string[] = [];
    const statoLabel = allStatoOptions.find(s => s.id === statoFilter)?.label;
    if (statoFilter !== 'tutti' && statoLabel) parts.push(statoLabel);
    const adminLabel = adminOptions.find(a => a.id === adminFilter)?.label;
    if (adminFilter !== 'tutti' && adminLabel) parts.push('Admin: ' + adminLabel);
    const valLabel = valutatoreOptions.find(v => v.id === valutatoreFilter)?.label;
    if (valutatoreFilter !== 'tutti' && valLabel) parts.push('Valutatore: ' + valLabel);
    azioniFilters.forEach(id => {
      const label = azioniOptions.find(a => a.id === id)?.label;
      if (label) parts.push(label);
    });
    return parts.length > 0 ? parts.join(' · ') : '';
  };
  const filterLabel = buildFilterLabel();
  const activeFiltersCount = (statoFilter !== 'tutti' ? 1 : 0) + (adminFilter !== 'tutti' ? 1 : 0) + (valutatoreFilter !== 'tutti' ? 1 : 0) + azioniFilters.length;
  const selectStyle = {
    height: '40px',
    padding: '0 32px 0 12px',
    border: '1px solid #E4E4E4',
    borderRadius: '9999px',
    fontSize: '14px',
    fontFamily: 'Roboto, sans-serif',
    color: '#2A3A54',
    backgroundColor: 'white',
    cursor: 'pointer',
    outline: 'none',
    appearance: 'none' as const,
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='7' viewBox='0 0 12 7'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%2380858E' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 12px center'
  };
  return <div className="space-y-6" data-id="element-775">
      {/* Page Header */}
      <div className="bg-white" style={{
      borderRadius: '8px',
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      padding: '24px 32px'
    }} data-id="element-776">
        <h1 style={{
        fontSize: '24px',
        fontWeight: 400,
        color: '#293B54',
        fontFamily: 'Roboto, sans-serif',
        margin: 0
      }} data-id="element-777">
          Gestione candidature - {activeTab.name}
          {filterLabel && <span style={{
          color: '#80858E',
          fontSize: '20px',
          marginLeft: '8px'
        }} data-id="element-778">
              ({filterLabel})
            </span>}
        </h1>
      </div>

      {/* Tab Bar Workspace */}
      <div className="bg-white flex items-center overflow-x-auto" style={{
      borderRadius: '8px',
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      padding: '0 32px',
      borderBottom: '1px solid #E4E4E4'
    }} data-id="element-779">
        <div className="flex items-end gap-2 pt-2" data-id="element-780">
          {tabs.map(tab => {
          const isActive = tab.id === activeTabId;
          const isEditing = tab.id === editingTabId;
          return <div key={tab.id} onClick={() => setActiveTabId(tab.id)} onDoubleClick={() => handleDoubleClickTab(tab)} className="group flex items-center gap-2 relative transition-colors" style={{
            padding: '14px 16px',
            paddingBottom: '12px',
            cursor: 'pointer',
            color: isActive ? '#293B54' : '#80858E',
            borderBottom: isActive ? '2px solid #2A97DF' : '2px solid transparent',
            fontFamily: 'Roboto Condensed, sans-serif',
            fontSize: '15px',
            fontWeight: isActive ? 500 : 400,
            marginBottom: '-1px'
          }} data-id="element-781">
                {isEditing ? <input ref={editInputRef} type="text" value={editTabName} onChange={e => setEditTabName(e.target.value)} onBlur={handleSaveTabName} onKeyDown={handleKeyDownTabName} style={{
              fontFamily: 'Roboto Condensed, sans-serif',
              fontSize: '15px',
              fontWeight: 500,
              color: '#293B54',
              border: 'none',
              outline: 'none',
              background: 'transparent',
              width: `${Math.max(editTabName.length * 9, 60)}px`,
              padding: 0
            }} data-id="element-782" /> : <span className="select-none whitespace-nowrap" data-id="element-783">
                    {tab.name}
                  </span>}

                {tabs.length > 1 && !isEditing && <button onClick={e => handleRemoveTab(e, tab.id)} className={`flex items-center justify-center rounded-full p-0.5 transition-colors ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`} style={{
              color: '#AAAAAA',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer'
            }} onMouseEnter={e => e.currentTarget.style.color = '#EA5455'} onMouseLeave={e => e.currentTarget.style.color = '#AAAAAA'} aria-label="Chiudi vista" data-id="element-784">
                    <Icon icon="tabler:x" fontSize={14} data-id="element-785" />
                  </button>}
              </div>;
        })}

          <button onClick={handleAddTab} className="flex items-center gap-1 transition-colors mb-2 ml-2" style={{
          padding: '8px 12px',
          color: '#AAAAAA',
          fontFamily: 'Roboto Condensed, sans-serif',
          fontSize: '14px',
          fontWeight: 400,
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          borderRadius: '4px'
        }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#F5F5F5'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'} data-id="element-786">
            <Icon icon="tabler:plus" fontSize={14} data-id="element-787" />
            Nuova vista
          </button>
        </div>
      </div>

      {/* Filter Panel */}
      <div className="bg-white" style={{
      borderRadius: '8px',
      boxShadow: 'none',
      border: '1px solid #E4E4E4'
    }} data-id="element-788">
        {/* Filter Header */}
        <div className="flex items-center justify-between" style={{
        padding: '14px 32px',
        borderBottom: '1px solid #E4E4E4'
      }} data-id="element-789">
          <div className="flex items-center" style={{
          gap: '8px'
        }} data-id="element-790">
            <Icon icon="tabler:filter" fontSize={18} style={{
            color: '#293B54'
          }} data-id="element-791" />
            <span style={{
            fontSize: '14px',
            fontWeight: 500,
            color: '#293B54',
            fontFamily: 'Roboto Condensed, sans-serif',
            letterSpacing: '0.3px'
          }} data-id="element-792">
              FILTRI
            </span>
            {activeFiltersCount > 0 && <span style={{
            backgroundColor: '#2A97DF',
            color: 'white',
            fontSize: '11px',
            fontWeight: 500,
            fontFamily: 'Roboto Condensed, sans-serif',
            padding: '2px 8px',
            borderRadius: '10px',
            lineHeight: '16px'
          }} data-id="element-793">
                {activeFiltersCount}
              </span>}
          </div>
          {activeFiltersCount > 0 && <button type="button" onClick={() => {
          updateActiveTab({
            statoFilter: 'tutti',
            adminFilter: 'tutti',
            valutatoreFilter: 'tutti',
            azioniFilters: [],
            currentPage: 1
          });
        }} style={{
          background: 'none',
          border: 'none',
          color: '#EA5455',
          fontSize: '13px',
          fontFamily: 'Roboto, sans-serif',
          fontWeight: 500,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          padding: '4px 8px',
          borderRadius: '9999px'
        }} className="hover:bg-red-50 transition-colors" data-id="element-794">
              <Icon icon="tabler:x" fontSize={14} data-id="element-795" />
              Resetta tutto
            </button>}
        </div>

        {/* Filter Controls */}
        <div className="flex items-start flex-wrap" style={{
        padding: '20px 32px',
        gap: '24px'
      }} data-id="element-796">
          {/* Stato */}
          <div className="flex flex-col" style={{
          gap: '6px'
        }} data-id="element-797">
            <label style={{
            fontSize: '11px',
            fontWeight: 500,
            color: '#80858E',
            fontFamily: 'Roboto Condensed, sans-serif',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }} data-id="element-798">
              Stato candidatura
            </label>
            <select value={statoFilter} onChange={e => handleStatoChange(e.target.value)} style={{
            ...selectStyle,
            minWidth: '260px',
            borderColor: statoFilter !== 'tutti' ? '#2A97DF' : '#E4E4E4'
          }} data-id="element-799">
              <option value="tutti" data-id="element-800">Tutti gli stati</option>
              {statoGroups.map(group => <optgroup key={group.group} label={group.group} data-id="element-801">
                  {group.options.map(opt => <option key={opt.id} value={opt.id} data-id="element-802">
                      {opt.label}
                    </option>)}
                </optgroup>)}
            </select>
          </div>

          {/* Vertical Divider */}
          <div style={{
          width: '1px',
          height: '58px',
          backgroundColor: '#E4E4E4',
          flexShrink: 0
        }} data-id="element-803" />

          {/* Admin */}
          <div className="flex flex-col" style={{
          gap: '6px'
        }} data-id="element-804">
            <label style={{
            fontSize: '11px',
            fontWeight: 500,
            color: '#80858E',
            fontFamily: 'Roboto Condensed, sans-serif',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }} data-id="element-805">
              Admin
            </label>
            <select value={adminFilter} onChange={e => {
            updateActiveTab({
              adminFilter: e.target.value,
              currentPage: 1
            });
          }} style={{
            ...selectStyle,
            minWidth: '200px',
            borderColor: adminFilter !== 'tutti' ? '#2A97DF' : '#E4E4E4'
          }} data-id="element-806">
              {adminOptions.map(opt => <option key={opt.id} value={opt.id} data-id="element-807">
                  {opt.label}
                </option>)}
            </select>
          </div>

          {/* Vertical Divider */}
          <div style={{
          width: '1px',
          height: '58px',
          backgroundColor: '#E4E4E4',
          flexShrink: 0
        }} data-id="element-808" />

          {/* Valutatore */}
          <div className="flex flex-col" style={{
          gap: '6px',
          opacity: isValutatoreRelevant ? 1 : 0.4,
          transition: 'opacity 0.2s ease'
        }} title={!isValutatoreRelevant ? 'Non applicabile per lo stato selezionato' : undefined} data-id="element-809">
            <label style={{
            fontSize: '11px',
            fontWeight: 500,
            color: '#80858E',
            fontFamily: 'Roboto Condensed, sans-serif',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }} data-id="element-810">
              Valutatore
              {!isValutatoreRelevant && <span style={{
              fontSize: '10px',
              fontWeight: 400,
              marginLeft: '4px',
              color: '#AAAAAA',
              textTransform: 'none'
            }} data-id="element-811">
                  — n/a
                </span>}
            </label>
            <select value={valutatoreFilter} disabled={!isValutatoreRelevant} onChange={e => {
            updateActiveTab({
              valutatoreFilter: e.target.value,
              currentPage: 1
            });
          }} style={{
            ...selectStyle,
            minWidth: '200px',
            borderColor: !isValutatoreRelevant ? '#EEEEEE' : valutatoreFilter !== 'tutti' ? '#2A97DF' : '#E4E4E4',
            cursor: isValutatoreRelevant ? 'pointer' : 'not-allowed',
            backgroundColor: isValutatoreRelevant ? 'white' : '#F5F5F5'
          }} data-id="element-812">
              {valutatoreOptions.map(opt => <option key={opt.id} value={opt.id} data-id="element-813">
                  {opt.label}
                </option>)}
            </select>
          </div>

          {/* Vertical Divider */}
          <div style={{
          width: '1px',
          height: '58px',
          backgroundColor: '#E4E4E4',
          flexShrink: 0
        }} data-id="element-814" />

          {/* Azioni Pendenti */}
          <div className="flex flex-col" style={{
          gap: '6px',
          opacity: isAzioniRelevant ? 1 : 0.4,
          transition: 'opacity 0.2s ease'
        }} title={!isAzioniRelevant ? 'Non applicabile per lo stato selezionato' : undefined} data-id="element-815">
            <label style={{
            fontSize: '11px',
            fontWeight: 500,
            color: '#80858E',
            fontFamily: 'Roboto Condensed, sans-serif',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }} data-id="element-816">
              Azioni pendenti
              {!isAzioniRelevant && <span style={{
              fontSize: '10px',
              fontWeight: 400,
              marginLeft: '4px',
              color: '#AAAAAA',
              textTransform: 'none'
            }} data-id="element-817">
                  — n/a
                </span>}
            </label>
            <div className="flex items-center" style={{
            gap: '8px'
          }} data-id="element-818">
              {azioniOptions.map(azione => {
              const isActive = azioniFilters.includes(azione.id);
              return <button key={azione.id} type="button" disabled={!isAzioniRelevant} onClick={() => toggleAzione(azione.id)} style={{
                height: '40px',
                padding: '0 16px',
                borderRadius: '9999px',
                border: !isAzioniRelevant ? '1px solid #EEEEEE' : isActive ? '1.5px solid #2A97DF' : '1px solid #E4E4E4',
                backgroundColor: !isAzioniRelevant ? '#F5F5F5' : isActive ? '#D7EDFF' : 'white',
                color: !isAzioniRelevant ? '#CCCCCC' : isActive ? '#0E74B8' : '#444444',
                fontSize: '13px',
                fontFamily: 'Roboto, sans-serif',
                fontWeight: isActive && isAzioniRelevant ? 500 : 400,
                cursor: isAzioniRelevant ? 'pointer' : 'not-allowed',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                transition: 'all 0.15s ease',
                whiteSpace: 'nowrap'
              }} data-id="element-819">
                    <Icon icon={isActive && isAzioniRelevant ? 'tabler:check' : 'tabler:circle-dashed'} fontSize={15} data-id="element-820" />
                    {azione.label}
                  </button>;
            })}
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="bg-white" style={{
      borderRadius: '8px',
      boxShadow: 'none',
      border: '1px solid #E4E4E4'
    }} data-id="element-821">
        {/* Search Bar */}
        <div className="flex items-center" style={{
        padding: '16px 20px',
        borderBottom: '1px solid #E4E4E4',
        gap: '0'
      }} data-id="element-822">
          <div className="relative" style={{
          width: '280px'
        }} data-id="element-823">
            <Icon icon="tabler:search" fontSize={16} className="absolute left-3 top-1/2 -translate-y-1/2" style={{
            color: '#AAAAAA'
          }} data-id="element-824" />
            <input type="text" placeholder="Cerca candidature..." value={searchQuery} onChange={e => updateActiveTab({
            searchQuery: e.target.value
          })} className="w-full" style={{
            height: '36px',
            paddingLeft: '36px',
            paddingRight: '12px',
            border: '1px solid #E4E4E4',
            borderRight: 'none',
            borderRadius: '8px 0 0 8px',
            fontSize: '13px',
            fontFamily: 'Roboto, sans-serif',
            color: '#444444',
            outline: 'none'
          }} data-id="element-825" />
          </div>
          
        </div>

        {/* Table */}
        <div className="overflow-x-auto" data-id="element-826">
          <table className="w-full" style={{
          borderCollapse: 'collapse',
          minWidth: '1000px'
        }} data-id="element-827">
            {/* Header Row */}
            <thead data-id="element-828">
              <tr style={{
              backgroundColor: 'white',
              borderBottom: '2px solid #E4E4E4'
            }} data-id="element-829">
                <th className="text-left" style={{
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                width: '18%'
              }} data-id="element-830">
                  <ColumnFilter label="BANDO" value={filters.bando} onChange={v => handleFilterChange('bando', v)} placeholder="Filtra bando..." data-id="element-831" />
                </th>
                <th className="text-left" style={{
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                width: '12%'
              }} data-id="element-832">
                  <ColumnFilter label="SETTORE" value={filters.settore} onChange={v => handleFilterChange('settore', v)} placeholder="Filtra settore..." data-id="element-833" />
                </th>
                <th className="text-left" style={{
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                width: '10%'
              }} data-id="element-834">
                  <ColumnFilter label="CODICE" value={filters.codice} onChange={v => handleFilterChange('codice', v)} placeholder="Filtra codice..." data-id="element-835" />
                </th>
                <th className="text-left" style={{
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                width: '20%'
              }} data-id="element-836">
                  <ColumnFilter label="TITOLO" value={filters.titolo} onChange={v => handleFilterChange('titolo', v)} placeholder="Filtra titolo..." data-id="element-837" />
                </th>
                <th className="text-left" style={{
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                width: '18%'
              }} data-id="element-838">
                  <ColumnFilter label="DENOMINAZIONE" value={filters.denominazione} onChange={v => handleFilterChange('denominazione', v)} placeholder="Filtra denominazione..." data-id="element-839" />
                </th>
                <th className="text-left" style={{
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                width: '12%'
              }} data-id="element-840">
                  <ColumnFilter label="EMAIL SOGG. PR..." value={filters.email} onChange={v => handleFilterChange('email', v)} placeholder="Filtra email..." data-id="element-841" />
                </th>
                <th className="text-left" style={{
                padding: '12px 16px',
                fontSize: '12px',
                fontWeight: 500,
                color: '#293B54',
                fontFamily: 'Roboto, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                width: '10%',
                position: 'sticky',
                right: 0,
                backgroundColor: 'white',
                zIndex: 2,
                boxShadow: '-4px 0 8px -4px rgba(0,0,0,0.08)'
              }} data-id="element-842">
                  AZIONI
                </th>
              </tr>
            </thead>
            <tbody data-id="element-843">
              {candidatureData.map(row => <tr key={row.id} style={{
              backgroundColor: 'white',
              borderBottom: '1px solid #E4E4E4',
              cursor: 'pointer'
            }} className="hover:bg-blue-50 transition-colors" onClick={() => window.location.assign(`/candidature/${row.id}`)} data-id="element-844">
                  <td style={{
                padding: '14px 16px',
                fontSize: '14px',
                fontFamily: 'Roboto, sans-serif',
                color: '#444444'
              }} data-id="element-845">
                    {row.bando}
                  </td>
                  <td style={{
                padding: '14px 16px',
                fontSize: '14px',
                fontFamily: 'Roboto, sans-serif',
                color: '#2A97DF',
                cursor: 'pointer'
              }} data-id="element-846">
                    {row.settore}
                  </td>
                  <td style={{
                padding: '14px 16px',
                fontSize: '14px',
                fontFamily: 'Roboto, sans-serif',
                color: '#444444'
              }} data-id="element-847">
                    {row.codice}
                  </td>
                  <td style={{
                padding: '14px 16px',
                fontSize: '14px',
                fontFamily: 'Roboto, sans-serif',
                color: '#444444',
                maxWidth: '200px',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
              }} data-id="element-848">
                    {row.titolo}
                  </td>
                  <td style={{
                padding: '14px 16px',
                fontSize: '14px',
                fontFamily: 'Roboto, sans-serif',
                color: '#444444'
              }} data-id="element-849">
                    {row.denominazione}
                  </td>
                  <td style={{
                padding: '14px 16px',
                fontSize: '14px',
                fontFamily: 'Roboto, sans-serif',
                color: '#444444'
              }} data-id="element-850">
                    {row.email}
                  </td>
                  <td style={{
                padding: '14px 16px',
                position: 'sticky',
                right: 0,
                backgroundColor: 'inherit',
                zIndex: 1,
                boxShadow: '-4px 0 8px -4px rgba(0,0,0,0.08)'
              }} data-id="element-851">
                    <div className="flex items-center gap-1" data-id="element-852">
                      <button type="button" className="p-1.5 hover:bg-gray-100 transition-colors" style={{
                    color: '#AAAAAA',
                    border: 'none',
                    background: 'transparent',
                    cursor: 'pointer',
                    borderRadius: '4px'
                  }} aria-label="Scarica PDF" onClick={e => e.stopPropagation()} data-id="element-853">
                        <Icon icon="tabler:file-type-pdf" fontSize={18} data-id="element-854" />
                      </button>
                      <Link to={`/candidature/${row.id}`} className="p-1.5 hover:bg-gray-100 transition-colors inline-flex" style={{
                    color: '#AAAAAA',
                    borderRadius: '4px'
                  }} aria-label="Visualizza dettaglio" onClick={e => e.stopPropagation()} data-id="element-855">
                        <Icon icon="tabler:eye" fontSize={18} data-id="element-856" />
                      </Link>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex items-center justify-end gap-4" style={{
        padding: '16px 24px',
        borderTop: '1px solid #E4E4E4'
      }} data-id="element-857">
          <div className="flex items-center gap-2" data-id="element-858">
            <span style={{
            fontSize: '14px',
            fontFamily: 'Roboto, sans-serif',
            color: '#444444'
          }} data-id="element-859">
              Righe per pagina:
            </span>
            <select value={rowsPerPage} onChange={e => updateActiveTab({
            rowsPerPage: Number(e.target.value),
            currentPage: 1
          })} style={{
            padding: '4px 8px',
            border: 'none',
            fontSize: '14px',
            fontFamily: 'Roboto, sans-serif',
            color: '#444444',
            cursor: 'pointer',
            outline: 'none'
          }} data-id="element-860">
              <option value={10} data-id="element-861">10</option>
              <option value={25} data-id="element-862">25</option>
              <option value={50} data-id="element-863">50</option>
            </select>
          </div>
          <span style={{
          fontSize: '14px',
          fontFamily: 'Roboto, sans-serif',
          color: '#444444'
        }} data-id="element-864">
            {startItem}-{endItem} di {totalItems}
          </span>
          <div className="flex items-center gap-1" data-id="element-865">
            <button type="button" onClick={() => updateActiveTab({
            currentPage: Math.max(1, currentPage - 1)
          })} disabled={currentPage === 1} className="p-1 rounded hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" style={{
            color: '#444444'
          }} aria-label="Pagina precedente" data-id="element-866">
              <Icon icon="tabler:chevron-left" fontSize={20} data-id="element-867" />
            </button>
            <button type="button" onClick={() => updateActiveTab({
            currentPage: currentPage + 1
          })} disabled={endItem >= totalItems} className="p-1 rounded hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" style={{
            color: '#444444'
          }} aria-label="Pagina successiva" data-id="element-868">
              <Icon icon="tabler:chevron-right" fontSize={20} data-id="element-869" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}